<template>
  <v-container fill-height fluid class="bg-image">
    <v-row justify="center" align="center">
      <v-dialog
        v-if="showMaintenance"
        v-model="showMaintenance"
        max-width="350px"
      >
        <v-container fluid class="ma-0 pa-0">
          <v-card class="elevation-0 ma-0 pa-0">
            <v-card-title class="primary white--text">
              Site em Manutenção
            </v-card-title>
            <v-card-text class="mt-2 text-center">
              O seu login não será bem sucedido enquanto o site estiver em manutenção. Agradecemos a sua compreensão!
            </v-card-text>
            <v-card-text class="justify-center">
              <v-avatar height="105" width="300" tile class="mx-auto d-block avatar-responsive">
                <v-img
                  src="@/assets/Maintenance/manutencao.png"
                  lazy-src="@/assets/Maintenance/manutencao.png"
                  contain
                />
              </v-avatar>
            </v-card-text>
            <v-card-text class="text-center">
              Tentaremos ser o mais breves possível!
            </v-card-text>
          </v-card>
        </v-container>
      </v-dialog>

      <v-col cols="12" md="4">
        <v-card
          :loading="loading"
          class="mx-auto my-12 align-self-center pa-5"
        >
          <template #progress>
            <v-progress-linear
              class="mb-8"
              color="primary"
              indeterminate
            />
          </template>

          <v-row justify="center">
            <v-avatar height="105" width="300" tile class="mt-2 mb-2 avatar-responsive">
              <img src="@/assets/fundo_conduril.png" />
            </v-avatar>
          </v-row>

          <v-row>
            <v-divider />
          </v-row>

          <v-card-title class="mt-2 primary--text justify-center title-responsive">
            ODC - Login
          </v-card-title>

          <ValidationObserver ref="credentialsForm" v-slot="{ invalid }">
            <v-form :disabled="loading" @submit.prevent="submit">
              <v-card-text>
                <v-col cols="12">
                  <validation-provider name="Email" vid="email" rules="required" v-slot="{ errors }">
                    <v-text-field
                      v-model="fields.email"
                      label="Email\\Username"
                      dense
                      outlined
                      prepend-inner-icon="mdi-account"
                      :error-messages="errors"
                      hide-details="auto"
                    />
                  </validation-provider>
                </v-col>

                <v-col cols="12">
                  <validation-provider name="Password" vid="password" rules="required" v-slot="{ errors }">
                    <v-text-field
                      v-model="fields.password"
                      dense
                      outlined
                      type="password"
                      label="Password"
                      prepend-inner-icon="mdi-lock"
                      :error-messages="errors"
                      hide-details="auto"
                    />
                  </validation-provider>
                </v-col>

                <v-row justify="center" class="mt-4">
                  <v-col cols="12">
                    <v-btn
                      type="submit"
                      block
                      rounded
                      class="btn-responsive success white--text"
                      :disabled="invalid || loading"
                    >
                      Login
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-form>
          </ValidationObserver>

          <v-row justify="center" class="mt-5">
            <div class="col-12 text-center pb-0"><p class="mb-0">Powered By</p></div>
            <a target="_blank" href="https://www.dreamdealtech.pt/">
              <v-avatar height="45" width="140" tile class="mt-2 mb-2">
                <img src="@/assets/logo.png" />
              </v-avatar>
            </a>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <ErrorSnackbar :timeout="4000" v-model="error" :message="error_message" />
  </v-container>
</template>

<script>
import Input from "@/components/UI/Inputs/Input";
import Form from "@/components/UI/Forms/Form";
import ErrorSnackbar from "@/components/UI/Snackbars/ErrorSnackbar";
import Button from "@/components/UI/Buttons/Button";
import User from '@/api/User.js';
import System from '@/api/System.js';

export default {
  components: { Input, Form, ErrorSnackbar, Button },
  data: () => ({
    showMaintenance: false,
    loading: false,
    fields: { email: null, password: null },
    error: false,
    error_message: "",
    system_status: null,
  }),
  mounted() {
    this.cleanCookies();

    if (this.$store.state.user.id != undefined) this.$store.dispatch("logout");
    
    System.status().then((resp) => {
      this.system_status = resp.data;
      this.showMaintenance = this.system_status.maintenance.value != "0";
    });
  },
  methods: {
    cleanCookies() {
      document.cookie = `XSRF-TOKEN=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${process.env.VUE_APP_MY_DOMAIN}`;
      document.cookie.split(";").forEach((cookie) => {
        const [name] = cookie.split("=");
        document.cookie = `${name.trim()}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname}`;
      });
    },
    login() {
      this.$store
        .dispatch("login", this.fields)
        .then((res) => {
          if (res.data.two_factor) {
            this.$router.push("/mfa");
            return;
          }
          localStorage.setItem('auth', '1');
          this.$router.push("/dashboard");
        })
        .catch((err) => {
          this.error = true;
          this.error_message =
            "Login inválido! Por favor verifique as suas credenciais ou entre em contacto com a equipa de suporte.";
          if (err.response?.status == 422) {
            return;
          }
          this.loading = false;
        });
    },
    async submit() {
      this.loading = true;
      await this.$store
        .dispatch("logout", this.fields)
        .then(() => {
          this.login();
        })
        .catch(() => {
          this.login();
        });
    },
  },
};
</script>

<style scoped>
.bg-image {
  background-image: url("@/assets/fundo.jpg");
  background-position: center;
  background-size: cover;
}

.avatar-responsive { max-width: 100%; }
@media (max-width: 600px) {
  .avatar-responsive { width: 80vw !important; height: auto !important; }
}
@media (max-width: 360px) {
  .avatar-responsive { width: 86vw !important; }
}

.title-responsive { text-align: center; }
@media (max-width: 480px) { .title-responsive { font-size: 1.1rem !important; } }
@media (max-width: 360px) { .title-responsive { font-size: 1rem !important; } }

.btn-responsive { white-space: normal !important; }
.btn-responsive .v-btn__content { line-height: 1.2; }
@media (max-width: 480px) {
  .btn-responsive { min-height: 40px; padding-left: 12px; padding-right: 12px; }
  .btn-responsive .v-btn__content { font-size: 0.95rem; }
}
@media (max-width: 360px) {
  .btn-responsive { min-height: 38px; padding-left: 10px; padding-right: 10px; }
  .btn-responsive .v-btn__content { font-size: 0.85rem; }
}

.link-responsive { white-space: normal !important; }
@media (max-width: 360px) { .link-responsive { font-size: 0.9rem !important; } }
</style>